"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var composition_api_1 = require("@vue/composition-api");
var componentName = 'wok-panel-sub-menu';
exports.default = composition_api_1.defineComponent({
    name: componentName,
    props: {
        icon: {
            type: String,
            default: undefined
        },
        title: {
            type: String,
            required: true
        }
    },
    setup: function (props, context) {
        var subMenuActive = composition_api_1.ref(false);
        var wrapperClasses = composition_api_1.computed(function () {
            return {
                'wok--panel-sub-menu__wrapper': true,
                'wok--panel-sub-menu--active': subMenuActive.value
            };
        });
        var appropriateAccessory = composition_api_1.computed(function () {
            if (subMenuActive.value) {
                return 'wok-icon-up-sm-16';
            }
            return 'wok-icon-down-sm-16';
        });
        return {
            subMenuActive: subMenuActive,
            wrapperClasses: wrapperClasses,
            appropriateAccessory: appropriateAccessory
        };
    }
});
